const Drawer = {
  baseStyle: {
    dialogContainer: {
      zIndex: "10000",
    },
    overlay: {
      zIndex: "9999",
    },
    closeButton: {
      right: "2",
      top: "2",
    },
  },
  variants: {
    right: {
      dialog: {
        borderLeftRadius: "3xl",
      },
    },
    bottom: {
      dialog: {
        borderTopRadius: "3xl",
        maxHeight: "95%",
      },
    },
    left: {
      dialog: {
        borderRightRadius: "3xl",
      },
    },
    top: {
      dialog: {
        borderBottomRadius: "3xl",
        maxHeight: "95%",
      },
    },
  },
};

export default Drawer;
